import ActionsProvider from '../../../../context/ActionsProvider';
import { useGlobalPageActions } from '../../../../hooks/useGlobalBlockActions';

function InterfaceAppActionProvider({ children }: { children: React.ReactNode }) {
  const { onAction } = useGlobalPageActions();
  return <ActionsProvider onAction={onAction}>{children}</ActionsProvider>;
}

export default InterfaceAppActionProvider;
